import Kampagnen from '@/models/kampagnen';
import axios from 'redaxios';

let loadingPromise;

export const kampagnenLoader = {
  methods: {
    loadKampagnen() {
      if (!loadingPromise) {
        loadingPromise = axios.get('/api/kampagnen').then(({ data }) => {
          data.forEach(kampagne => {
            kampagne.geaendertam = new Date(kampagne.geaendertam).getTime();
          });
          return Kampagnen.insertOrUpdate({ data });
        });
      }
      return loadingPromise;
    }
  }
};
